import React from 'react';
import { DATA_TABLE_SOURCE_SUNSETUP_DRIVERS } from 'common/dataTableConstants';

import useDispatch from 'client/hooks/useDispatch';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrDataTableConnected from 'client/components/SrDataTableConnected';
import SrDataTableUI from 'client/components/SrDataTableUI';

import { SR_TABLE_THEME_HISTORICAL } from 'client/components/SrTable';
import { SR_API_ACTION_DRIVERS_UPDATE_STATUS } from 'api/actionTypes';
import { DRIVER_STATUS_ACTIVE, DRIVER_STATUS_INACTIVE } from 'common/jobConstants';
import postWithState from 'client/actions/postWithState';

function getDataTableSettingsFromProps() {
  const dataTableSettings = {
    dataSource: DATA_TABLE_SOURCE_SUNSETUP_DRIVERS,
    rootViewId: DATA_TABLE_SOURCE_SUNSETUP_DRIVERS,
    initialViewSettings: {
      loadAllData: true,
      sort: {
        status: 'asc',
      },
    },
    itemsPropName: 'items',
  };
  return dataTableSettings;
}

const SrDriversDataTable = ({ maxHeight }) => {
  const dispatch = useDispatch();

  const headers = [
    {
      content: 'Name',
      dataTableFieldId: 'driverName',
      width: '40%',
    },
    {
      content: 'Status',
      dataTableFieldId: 'status',
      width: '20%',
    },
    {
      content: 'Market',
      dataTableFieldId: 'marketDisplayName',
      width: '25%',
    },
    {
      content: 'Actions',
      width: '15%',
    },
  ];

  const updateDriverStatus = ({ driverId, status, onSuccess }) => {
    return dispatch(postWithState, {
      action: SR_API_ACTION_DRIVERS_UPDATE_STATUS,
      payload: {
        driverId,
        status,
      },
      onSuccess,
    });
  };

  return (
    <SrBox maxHeight={maxHeight || 'none'} overflowY="scroll">
      <SrDataTableConnected {...getDataTableSettingsFromProps()}>
        {({
          items,
          reloadItems,
          viewSettings,
          dataTableApiState,
          onInfiniteScrollWrapperRef,
          dataTableIsFullyLoaded,
        }) => {
          // eslint-disable-line max-len
          if (items.length === 0 && dataTableIsFullyLoaded) {
            return (
              <SrText font="greycliff" weight="500" fontSize="16px">
                No drivers found.
              </SrText>
            );
          }
          return (
            <div ref={onInfiniteScrollWrapperRef}>
              <SrDataTableUI
                sticky
                theme={SR_TABLE_THEME_HISTORICAL}
                dataTableViewSettings={viewSettings}
                headers={headers}
                minWidth="100%"
                rows={items.map((item) => {
                  return {
                    cells: [
                      {
                        content: item.driverName,
                      },
                      {
                        content: item.status,
                        style: {
                          color: item.status === DRIVER_STATUS_ACTIVE ? 'green' : '#FF0000',
                        },
                      },
                      {
                        content: item.marketDisplayName,
                      },
                      {
                        content: (
                          <SrText
                            color="blue300"
                            cursor="pointer"
                            onClick={() =>
                              updateDriverStatus({
                                driverId: item.id,
                                status:
                                  item.status === DRIVER_STATUS_ACTIVE
                                    ? DRIVER_STATUS_INACTIVE
                                    : DRIVER_STATUS_ACTIVE,
                                onSuccess: () => {
                                  return reloadItems({
                                    count: 1,
                                    filter: { 'drivers.id': item.id },
                                  });
                                },
                              })
                            }
                          >
                            {item.status === DRIVER_STATUS_ACTIVE ? 'Deactivate' : 'Activate'}
                          </SrText>
                        ),
                      },
                    ],
                  };
                })}
              />
              {dataTableApiState.inProgress && (
                <div>
                  <div className="loading-gif clearfix" />
                </div>
              )}
            </div>
          );
        }}
      </SrDataTableConnected>
    </SrBox>
  );
};

export default SrDriversDataTable;
